import { FaTruck, FaUserMd, FaPills } from "react-icons/fa"; // Import Font Awesome icons

const OverlappingCards = () => {
  return (
    <section id="service" className="py-16 relative bg-white lg:h-[80vh] mt-[10rem]">
      <div className="container mx-auto px-4">
        <div className="relative flex flex-col items-center lg:grid lg:grid-cols-3 lg:gap-x-8">
          <p className="text-center text-3xl lg:text-5xl mb-10 underline text-green-600 font-bold col-span-3">
            Our Services
          </p>

          {/* Card 1 */}
          <div className="bg-white p-6 shadow-lg rounded-lg z-30 relative w-[85%] h-[200px] mb-8 transform transition-transform duration-300 hover:scale-105 translate-y-0 translate-x-0 lg:w-full lg:h-[200px] lg:translate-x-0 lg:translate-y-0">
            <div className="flex items-center space-x-4">
              <FaTruck className="text-green-600 text-6xl" />
              <div>
                <h2 className="text-green-600 font-bold lg:text-2xl">
                  Fast Delivery
                </h2>
                <p className="text-gray-700 lg:text-xl">
                  Get your medications delivered to your doorstep on time.
                </p>
              </div>
            </div>
          </div>

          {/* Card 2 */}
          <div className="bg-white p-6 pt-10 shadow-lg rounded-lg z-20 relative w-[85%] h-[270px] mb-8 transform transition-transform duration-300 hover:scale-105 -translate-y-6 translate-x-6 lg:w-full lg:h-[240px] lg:translate-x-0 lg:translate-y-0">
            <div className="flex items-center space-x-4">
              <FaUserMd className="text-green-600 text-6xl" />
              <div>
                <h2 className="text-green-600 font-bold lg:text-2xl">
                  Trusted Pharmacists
                </h2>
                <p className="text-gray-700 lg:text-xl">
                  We ensure safe and reliable medications prescribed by experts.
                </p>
              </div>
            </div>
          </div>

          {/* Card 3 */}
          <div className="bg-white py-8 pt-10 px-6 shadow-lg rounded-lg z-10 relative w-[85%] h-[250px] transform transition-transform duration-300 hover:scale-105 -translate-y-12 translate-x-12 lg:w-full lg:h-[250px] lg:translate-x-0 lg:translate-y-0">
            <div className="flex items-center space-x-4">
              <FaPills className="text-green-600 text-7xl" />
              <div>
                <h2 className="text-green-600 font-bold lg:text-2xl">
                  Wide Range
                </h2>
                <p className="text-gray-700 lg:text-xl">
                  We provide access to a variety of over-the-counter and
                  prescription drugs.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OverlappingCards;
